import { render, staticRenderFns } from "./SSCommentEditor.vue?vue&type=template&id=5509f87e&scoped=true&"
import script from "./SSCommentEditor.vue?vue&type=script&lang=js&"
export * from "./SSCommentEditor.vue?vue&type=script&lang=js&"
import style0 from "./SSCommentEditor.vue?vue&type=style&index=0&id=5509f87e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5509f87e",
  null
  
)

export default component.exports